// extracted by mini-css-extract-plugin
export default {"wrapper":"basic-event-info_wrapper__v5Kuz","infoWrapper":"basic-event-info_infoWrapper__25CNd","accessCode":"basic-event-info_accessCode__dWzKc"};